import React from 'react';
import { EdgeProps, getSmoothStepPath } from 'reactflow';

const CustomEdge: React.FC<EdgeProps> = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style,
  markerEnd,
  data,
}) => {
  const deleteEdge = () => {
    if (data?.onDelete) {
      data.onDelete(id);
    }
  };

  const [edgePath, labelX, labelY] = getSmoothStepPath({
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition,
  });

const position = 'start';
let x = sourceX;
let y = sourceY;

if (position === 'start') {
    const offsetX = 10;  // move slightly left
    const offsetY = -10;  // move slightly up

    x = sourceX + offsetX;
    y = sourceY + offsetY;
}

  return (
    <g>
      <path
        d={edgePath}
        style={{
          strokeWidth: 3,
          stroke: "rgba(94, 86, 86, 0.87)",
          fill: "none",
          ...style,
        }}
        markerEnd={markerEnd}
      />

      {/* Delete button on the edge */}
      <foreignObject
        // x={labelX - 10}
        // y={labelY - 10}
        x={x}
        y={y}
        width={20}
        height={20}
      >
        <div
          style={{
            background: '#fff',
            borderRadius: '50%',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '20px',
            height: '20px',
            boxShadow: '0 0 2px rgba(0,0,0,0.5)',
            color: 'red',             
            fontWeight: 'bold',  
            fontSize: '14px',         
          }}
          onClick={deleteEdge}
        >
          ❌
        </div>
      </foreignObject>
      
    </g>
  );
};

export default CustomEdge;

